import React, { useState } from 'react';
import Header from '@/components/layout/Header';
import Sidebar from '@/components/layout/Sidebar';
import Widget from '@/components/layout/Widget';
import { LayoutProvider } from '@/context/useLayoutContext';
import { showWidgetContainer } from '@/constants';
import { PageContent } from '@/styles';
import clsx from 'clsx';
import Footer from '@/components/vietrro/Footer';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const handleCollapsed = () => {
    setSidebarCollapsed((prev) => !prev);
  }

  return (
    <LayoutProvider>
      <PageContent>
        <Header />
        <div className='mt-[80px] flex space-x-6 px-3 pb-8 relative'>
          <Sidebar isCollapsed={sidebarCollapsed} toggleSidebar={handleCollapsed} />
 
          <PageContent className={clsx(
            'grow',
            showWidgetContainer && 'flex flex-row space-x-6'
          )}>
            {children}
            {showWidgetContainer && (
              <div className='max-w-sm rounded-lg'>
                <Widget />
              </div>
            )}
          </PageContent>
        </div>

        <Footer />
      </PageContent>
    </LayoutProvider>
  );
};

export default MainLayout;
